import React from "react";

import GameCard from "../../Components/Test/GameCard";
import GameList from "../../Components/Test/GameListDemo";

const TestGameList = () => {
  return (
    <main className="min-h-screen bg-light-green">
      <GameList />
    </main>
  );
};

export default TestGameList;
